// 矿山种类
export const mineOptions = ['煤（地下开采）', '煤（露天开采）', '石油', '油页岩', '烃类天然气', '二氧化碳气', '煤成(层)气', '地热(热水)', '地热(热气)', '放射性矿产', '金(岩金)', '金(砂金船采)', '金(砂金机采)', '银', '其他贵金属', '铁（地下开采）', '铁（露天开采）', '锰', '铬、钛、钒', '铜', '铅', '锌', '钨', '锡', '锑', '铝土矿', '钼', '镍', '钴', '镁', '铋', '汞', '稀土、稀有金属', '石灰岩', '硅石', '白云岩', '耐火粘土', '萤石', '硫铁矿', '自然硫', '磷矿', '蛇纹岩', '硼矿', '岩盐、井盐', '湖盐', '钾盐', '芒硝', '碘', '砷、雌黄、雄黄、毒砂', '金刚石', '宝石', '云母', '石棉', '重晶石', '石膏', '滑石', '长石', '高岭土、瓷土等', '膨润土', '叶蜡石', '沸石', '石墨', '玻璃用砂、砂岩', '水泥用砂岩', '建筑石料', '建筑用砂、砖瓦粘土', '页岩', '矿泉水']
// 企业类型
export const industryOptions = [{
  value: 1,
  label: '工业风险单元',
  children: [{
    disabled: false,
    value: 107,
    label: '冶金企业'
  }, {
    disabled: false,
    value: 108,
    label: '有色企业'
  }, {
    disabled: false,
    value: 110,
    label: '建材企业'
  }, {
    disabled: false,
    value: 121,
    label: '轻工企业'
  }, {
    disabled: false,
    value: 111,
    label: '机械企业'
  }, {
    disabled: false,
    value: 112,
    label: '纺织企业'
  }, {
    disabled: false,
    value: 101,
    label: '危险化学品生产企业'
  }, {
    disabled: false,
    value: 102,
    label: '带储存的危险化学品经营企业'
  }, {
    disabled: false,
    value: 103,
    label: '危险化学品使用企业'
  }, {
    disabled: false,
    value: 104,
    label: '加油站'
  }, {
    disabled: false,
    value: 114,
    label: '露天矿山'
  }, {
    disabled: false,
    value: 117,
    label: '烟花爆竹企业'
  }, {
    disabled: false,
    value: 109,
    label: '民用爆炸物品企业'
  }, {
    disabled: false,
    value: 310,
    label: '渔业船舶'
  }, {
    disabled: false,
    value: 140,
    label: '加油加气站'
  }, {
    disabled: false,
    value: 141,
    label: '加气站'
  }, {
    disabled: false,
    value: 105,
    label: '天然气站场'
  }, {
    disabled: false,
    value: 106,
    label: '液化气储配站'
  }, {
    disabled: false,
    value: 144,
    label: '船舶修造企业'
  }, {
    disabled: false,
    value: 118,
    label: '港口经营企业'
  }, {
    disabled: false,
    value: 145,
    label: '危险废物处置企业'
  }]
}, {
  disabled: false,
  value: 2,
  label: '人员密集单元',
  children: [{
    disabled: false,
    value: 211,
    label: '商场'
  }, {
    disabled: false,
    value: 223,
    label: '市场'
  }, {
    disabled: false,
    value: 205,
    label: '体育场馆'
  },
  {
    disabled: false,
    value: 206,
    label: '旅游景区'
  },
  {
    disabled: false,
    value: 207,
    label: '学校'
  }, {
    disabled: false,
    value: 230,
    label: '校外培训机构（教育局）'
  }, {
    disabled: false,
    value: 613,
    label: '校外培训机构（文旅局）'
  }, {
    disabled: false,
    value: 614,
    label: '校外培训机构（科技局）'
  }, {
    disabled: false,
    value: 615,
    label: '校外培训机构（体育局）'
  }, {
    disabled: false,
    value: 616,
    label: '校外培训机构（人社局）'
  }, {
    disabled: false,
    value: 204,
    label: '宗教活动场所'
  }, {
    disabled: false,
    value: 216,
    label: '星级饭店（酒店）'
  }, {
    disabled: false,
    value: 208,
    label: '非星级酒店'
  }, {
    disabled: false,
    value: 201,
    label: '餐饮场所'
  }, {
    disabled: false,
    value: 202,
    label: '医疗机构'
  },
  // {
  //   disabled: false,
  //   value: 203,
  //   label: '高层建筑'
  // },
  {
    disabled: false,
    value: 209,
    label: '养老机构'
  },
  {
    disabled: false,
    value: 501,
    label: '社会福利机构'
  },
  {
    disabled: false,
    value: 502,
    label: '救助站'
  },
  {
    disabled: false,
    value: 210,
    label: '公共休闲娱乐场所'
  },
  {
    disabled: false,
    value: 213,
    label: '技工院校'
  },
  {
    disabled: false,
    value: 219,
    label: '职业技能培训机构'
  },
  {
    disabled: false,
    value: 220,
    label: '托育机构'
  }, {
    disabled: false,
    value: 228,
    label: '风景名胜区（林业局）'
  }, {
    disabled: false,
    value: 231,
    label: '电影放映场所'
  }, {
    disabled: false,
    value: 304,
    label: '客运车站'
  }, {
    value: 332,
    label: '城市公园（国有资产监督管理委员会）'
  }, {
    value: 503,
    label: '公共文化场所（文化和旅游局）'
  }, {
    value: 601,
    label: '风景名胜区（园林中心）'
  }, {
    value: 602,
    label: '演出场所'
  }, {
    value: 603,
    label: '城市公园(城乡建设局)'
  }, {
    value: 604,
    label: '城市公园（市园林中心）'
  }, {
    value: 605,
    label: '城市公园（林业局）'
  }, {
    value: 606,
    label: '公共文化场所（文物局）'
  }, {
    value: 607,
    label: '公共文化场所（自规局）'
  }, {
    value: 608,
    label: '公共文化场所（科技局）'
  }, {
    value: 609,
    label: '公共文化场所（共青团委）'
  }, {
    value: 610,
    label: '民宿'
  }, {
    value: 617,
    label: '风景名胜区（鼓岭管委会）'
  } ]
}, {
  disabled: false,
  value: 3,
  label: '公共设施单元',
  children: [{
    disabled: false,
    value: 322,
    label: '城市轨道交通' // 新
  }, {
    disabled: false,
    value: 301,
    label: '公路桥梁' // 新
  }, {
    disabled: false,
    value: 504,
    label: '市政桥梁（城管）' // 新
  }, {
    disabled: false,
    value: 302,
    label: '公路隧道' // 新
  }, {
    disabled: false,
    value: 505,
    label: '市政隧道（城管）' // 新
  }, {
    disabled: false,
    value: 319,
    label: '公路客运企业'  // 新
  }, {
    disabled: false,
    value: 321,
    label: '城市公共交通（短途客运企业）' // 新
  }, {
    disabled: false,
    value: 309,
    label: '建筑垃圾消纳场'
  }, {
    disabled: false,
    value: 303,
    label: '水库大坝' // 新
  }, {
    disabled: false,
    value: 320,
    label: '水路旅客运输企业' // 新
  }, {
    disabled: false,
    value: 335,
    label: '水路货物运输企业'
  }, {
    disabled: false,
    value: 314,
    label: '普通货物运输企业' // 新
  }, {
    value: 308,
    label: '危险货物运输企业'
  }, {
    disabled: false,
    value: 139,
    label: '房屋建筑工程'
  }, {
    disabled: false,
    value: 403,
    label: '市政基础设施工程'
  }, {
    disabled: false,
    value: 135,
    label: '水利工程建设'
  }, {
    disabled: false,
    value: 133,
    label: '公路、水运工程建设'
  }, {
    disabled: false,
    value: 134,
    label: '城市轨道交通建设'
  }, {
    value: 316,
    label: '城市供水企业'
  }, {
    value: 317,
    label: '城市污水处理企业'
  }, {
    value: 611,
    label: '市政桥梁（建设局）'
  }, {
    value: 612,
    label: '市政隧道（建设局）'
  }, {
    value: 618,
    label: '防溺水点'
  } ]
}
//  {
//   disabled: false,
//   value: 2,
//   label: '建设工程单元',
//   children: [{
//     disabled: false,
//     value: 134,
//     label: '城市轨道交通建设' // 房地产业(含房地产开发、房屋征收拆迁等)
//   }, {
//     disabled: false,
//     value: 139,
//     label: '房屋建筑工程' // 房地产业(含房地产开发、房屋征收拆迁等)
//   }, {
//     disabled: false,
//     value: 133,
//     label: '公路、水运工程建设' // 公路、水运工程
//   }, {
//     disabled: false,
//     value: 135,
//     label: '水利工程建设'
//   }, {
//     disabled: false,
//     value: 403,
//     label: '市政基础设施工程'
//   }]
// }, {
//   disabled: false,
//   value: 3,
//   label: '交通运输单元',
//   children: [{
//     disabled: false,
//     value: 314,
//     label: '普通货物运输企业' // 新
//   }, {
//     disabled: false,
//     value: 319,
//     label: '公路客运企业' // 新
//   }, {
//     disabled: false,
//     value: 308,
//     label: '危险货物道路运输企业'
//   }, {
//     disabled: false,
//     value: 320,
//     label: '水路旅客运输企业' // 新
//   }, {
//     disabled: false,
//     value: 321,
//     label: '城市公共交通（短途客运企业）' // 新
//   }, {
//     disabled: false,
//     value: 322,
//     label: '城市轨道交通' // 新
//   }, {
//     value: 301,
//     label: '危病桥梁'
//   }, {
//     value: 302,
//     label: '危病隧道'
//   }, {
//     disabled: false,
//     value: 335,
//     label: '水路货物运输企业'
//   }]
// }
]
// 风险等级
export const levelOptions = [{label: '红色风险', value: 1}, {label: '橙色风险', value: 2}, {label: '黄色风险', value: 3}, {label: '蓝色风险', value: 4}]
export const standardOptions = ['一级达标', '二级达标', '三级达标', '小微达标', '未创建', '不涉及']
export const isStandardOptions = ['一级达标', '二级达标', '三级达标', '小微达标']
export const isFuneralOptions = ['一级', '二级', '三级']
export const isfireStandardOptions = ['已达标']

// 单位规模
export const scaleOptions = ['大型', '中型', '小型', '微型']

// 人员类型
export const staffTypeOptions = ['主要负责人', '安全管理人员', '其他管理人员', '一线生产人员', '其他人员', '特种作业人员', '特种设备作业人员']

export const controlLevelOptions = {
  1: '岗位',
  2: '部门',
  3: '单位'
}

export const frequencyTypeOptions = {
  1: '小时',
  2: '天',
  3: '周',
  4: '月',
  5: '年'
}
export const standardOptionA = ['评审达标', '自评达标', '未创建标准化']

export const standardOptionB = ['国家标准', '省级标准', '福州标准']

export const standardOptionC = ['一级', '二级', '三级', '福州标准达标']

export const dangerOptions = ['动火作业', '有限空间作业', '高处作业', '吊装作业', '断路作业', '动土作业', '临时用电作业', '盲板抽堵作业']
export const rateColors = ['#99A9BF', '#F7BA2A', '#FF9900']
export const flowStatusOptions = [{ // 危险作业状态
  label: '未开始',
  value: 0
}, {
  label: '进行中',
  value: 1
}, {
  label: '已关闭',
  value: 2
}, {
  label: '逾期未关闭',
  value: 3
}]

export const clearStatusOptions = [{ // 销号状态
  label: '挂牌督办待审核',
  value: 1
}, {
  label: '打回一般隐患',
  value: 2
}, {
  label: '挂牌督办中',
  value: 3
}, {
  label: '摘牌销案待审核',
  value: 4
}, {
  label: '已摘牌销案',
  value: 5
}]

export const categoryOption = [
  {
    disabled: false,
    value: '基础管理',
    label: '基础管理',
    children: [
      {
        disabled: false,
        value: '生产经营单位资质证照类',
        label: '生产经营单位资质证照类'
      },
      {
        disabled: false,
        value: '安全生产管理机构及人员类',
        label: '安全生产管理机构及人员类'
      },
      {
        disabled: false,
        value: '安全生产责任制类',
        label: '安全生产责任制类'
      },
      {
        disabled: false,
        value: '安全生产管理制度类',
        label: '安全生产管理制度类'
      },
      {
        disabled: false,
        value: '安全操作规程类',
        label: '安全操作规程类'
      },
      {
        disabled: false,
        value: '教育培训类',
        label: '教育培训类'
      },
      {
        disabled: false,
        value: '安全生产管理档案类',
        label: '安全生产管理档案类'
      },
      {
        disabled: false,
        value: '安全生产投入类',
        label: '安全生产投入类'
      },
      {
        disabled: false,
        value: '应急管理类',
        label: '应急管理类'
      },
      {
        disabled: false,
        value: '特种设备基础管理类',
        label: '特种设备基础管理类'
      },
      {
        disabled: false,
        value: '职业卫生基础管理类',
        label: '职业卫生基础管理类'
      },
      {
        disabled: false,
        value: '相关方基础管理类',
        label: '相关方基础管理类'
      },
      {
        disabled: false,
        value: '其他基础管理类',
        label: '其他基础管理类'
      }
    ]
  },
  {
    disabled: false,
    value: '现场管理',
    label: '现场管理',
    children: [
      {
        disabled: false,
        value: '特种设备现场管理类',
        label: '特种设备现场管理类'
      },
      {
        disabled: false,
        value: '生产设备设施及工艺类',
        label: '生产设备设施及工艺类'
      },
      {
        disabled: false,
        value: '场所环境类',
        label: '场所环境类'
      },
      {
        disabled: false,
        value: '从业人员操作行为类',
        label: '从业人员操作行为类'
      },
      {
        disabled: false,
        value: '消防安全类',
        label: '消防安全类'
      },
      {
        disabled: false,
        value: '用电安全类',
        label: '用电安全类'
      },
      {
        disabled: false,
        value: '职业卫生现场安全类',
        label: '职业卫生现场安全类'
      },
      {
        disabled: false,
        value: '有限空间现场安全类',
        label: '有限空间现场安全类'
      },
      {
        disabled: false,
        value: '辅助动力系统类',
        label: '辅助动力系统类'
      },
      {
        disabled: false,
        value: '相关方现场管理类',
        label: '相关方现场管理类'
      },
      {
        disabled: false,
        value: '其他现场管理类',
        label: '其他现场管理类'
      }
    ]
  }
]

// 带有八大行业的企业类型
export const industryList = [{
  value: 1,
  label: '矿山',
  children: [{
    value: 114,
    label: '露天矿山'
  }]
}, {
  value: 2,
  label: '危险化学品',
  children: [{
    value: 101,
    label: '危险化学品生产企业'
  }, {
    disabled: false,
    value: 102,
    label: '带储存的危险化学品经营企业'
  }, {
    disabled: false,
    value: 103,
    label: '危险化学品使用企业'
  }, {
    disabled: false,
    value: 104,
    label: '加油站'
  } ]
}, {
  value: 3,
  label: '烟花爆竹',
  children: [{
    disabled: false,
    value: 117,
    label: '烟花爆竹企业'
  } ]
}, {
  value: 4,
  label: '交通运输',
  children: [{
    value: 322,
    label: '城市轨道交通（地铁）'
  }, {
    value: 321,
    label: '城市道路公共交通运营企业'
  }, {
    value: 308,
    label: '道路危险货物运输企业'
  }, {
    value: 319,
    label: '公路客运企业'
  } ]
}, {
  value: 5,
  label: '建筑施工',
  children: [{
    value: 139,
    label: '房屋建设'
  }]
}, {
  value: 6,
  label: '民用爆炸物品',
  children: [{
    value: 109,
    label: '民用爆炸物品企业'
  } ]
}, {
  value: 7,
  label: '金属冶炼',
  children: [{
    value: 107,
    label: '冶金企业'
  } ]
}, {
  value: 8,
  label: '渔业生产',
  children: [{
    value: 310,
    label: '渔业船舶'
  } ]
}, {
  value: 9,
  label: '工业风险单元',
  children: [{
    disabled: false, // 104
    value: 140,
    label: '加油加气站'
  }, {
    disabled: false, // 104
    value: 141,
    label: '加气站'
  }, {
    disabled: false,
    value: 108,
    label: '有色企业'
  }, {
    disabled: false,
    value: 110,
    label: '建材企业'
  }, {
    disabled: false,
    value: 121,
    label: '轻工企业'
  }, {
    disabled: false,
    value: 111,
    label: '机械企业'
  }, {
    disabled: false,
    value: 112,
    label: '纺织企业'
  }, {
    disabled: false, // 111
    value: 142,
    label: '汽车制造企业'
  }, {
    disabled: false, // 111
    value: 144,
    label: '船舶修造企业'
  }, {
    disabled: false,
    value: 105,
    label: '天然气站场'
  }, {
    disabled: false,
    value: 145,
    label: '危险废物处置企业'
  }, {
    disabled: false,
    value: 118,
    label: '港口经营企业'
  }, {
    disabled: false,
    value: 126,
    label: '机动车维修企业'
  }, {
    disabled: false,
    value: 106,
    label: '液化气储配站（含供应站）'
  }, {
    value: 330, // 111
    label: '民航设施维修产业'
  }]
}, {
  disabled: false,
  value: 10,
  label: '人员密集单元',
  children: [{
    disabled: false,
    value: 205,
    label: '体育场馆'
  }, {
    disabled: false,
    value: 202,
    label: '医疗机构'
  },{
    disabled: false,
    value: 203,
    label: '高层建筑'
  }, {
    disabled: false, // 208
    value: 216,
    label: '星级饭店（酒店）' // 公路、水运工程
  }, {
    disabled: false,
    value: 208,
    label: '宾馆酒店（非星级）'
  }, {
    disabled: false, // 208
    value: 217,
    label: '民宿'
  }, {
    disabled: false,
    value: 201,
    label: '餐饮场所'
  }, {
    disabled: false, // 207
    value: 213,
    label: '技工院校'
  }, {
    disabled: false, // 207
    value: 219,
    label: '职业技能培训机构'
  }, {
    disabled: false,
    value: 207,
    label: '学校'
  }, {
    disabled: false, // 207
    value: 220,
    label: '托育机构'
  }, {
    disabled: false,
    value: 209,
    label: '养老机构和福利机构'
  }, {
    disabled: false,
    value: 222,
    label: '殡仪服务场所'
  }, {
    disabled: false,
    value: 211,
    label: '商场'
  }, {
    disabled: false, // 211
    value: 223,
    label: '市场'
  }, {
    disabled: false,
    value: 204,
    label: '宗教场所'
  }, {
    disabled: false,
    value: 210,
    label: '文化娱乐行业'
  }, {
    disabled: false,
    value: 215,
    label: '文物和博物馆'
  }, {
    disabled: false,
    value: 224,
    label: '少年宫'
  },
  // {
  //   disabled: true,
  //   value: 225,
  //   label: '科技馆'
  // },
  {
    disabled: false,
    value: 226,
    label: '会展场馆'
  }, {
    disabled: false,
    value: 227,
    label: '会堂场馆'
  }, {
    disabled: false,
    value: 206,
    label: '旅游景区'
  }, {
    disabled: false, // 206
    value: 228,
    label: '风景名胜区'
  }, {
    disabled: false,
    value: 304,
    label: '客运车站'
  }, {
    disabled: false,
    value: 229,
    label: '驾校'
  }]
}, {
  disabled: false,
  value: 11,
  label: '公共设施单元',
  children: [{
    disabled: false,
    value: 133,
    label: '公路建设项目'
  }, {
    disabled: false,
    value: 135,
    label: '在建水利水电项目（水利局）'
  }, {
    disabled: false, // 135
    value: 323,
    label: '在建水电项目（工信局）'
  }, {
    disabled: false,
    value: 309,
    label: '建筑垃圾消纳场'
  }, {
    value: 325, // 113
    label: '发电企业（水力）（水利局）'
  }, {
    value: 326, // 113
    label: '发电企业（水力）（工信局）'
  }, {
    value: 327, // 113
    label: '发电企业（火力）'
  }, {
    value: 306,
    label: '陆上长输油气管道企业'
  }, {
    value: 315, // 111
    label: '快递企业'
  }, {
    value: 307,
    label: '城镇燃气管道企业'
  }, {
    value: 316,
    label: '城市供水企业'
  }, {
    value: 317,
    label: '污水处理企业'
  }, {
    value: 331, // 302
    label: '市政隧道（市政园林局）'
  }, {
    value: 302,
    label: '公路隧道（交通运输局）'
  }, {
    value: 332, // 206
    label: '城市公园'
  }, {
    value: 333, // 301
    label: '市政桥梁（市政园林局）'
  }, {
    value: 301,
    label: '公路桥梁（交通运输局）'
  }, {
    value: 314,
    label: '道路普通货物运输企业'
  }, {
    disabled: false,
    value: 335,
    label: '水路货物运输企业'
  }, {
    value: 320,
    label: '水路旅客运输企业'
  }, {
    value: 303,
    label: '水库大坝'
  }]
}]

// 安责险管理类型
export const insuranceManageType = [
  {
    id: 10,
    name: '煤矿',
    children: [
      {
        id: 1001,
        name: '煤矿(露天)'
      },
      {
        id: 1002,
        name: '煤矿(井工)'
      },
      {
        id: 1000,
        name: '其他'
      }
    ]
  },
  {
    id: 11,
    name: '非煤矿山',
    children: [
      {
        id: 1101,
        name: '石油天然气开采'
      },
      {
        id: 1102,
        name: '金属和非金属矿山(露天)'
      },
      {
        id: 1103,
        name: '金属和非金属矿山(井工)'
      },
      {
        id: 1100,
        name: '其他'
      }
    ]
  },
  {
    id: 12,
    name: '危险化学品',
    children: [
      {
        id: 1201,
        name: '生产'
      },
      {
        id: 1202,
        name: '经营'
      },
      {
        id: 1203,
        name: '零售'
      },
      {
        id: 1204,
        name: '加油(气)站'
      },
      {
        id: 1205,
        name: '仓储'
      },
      {
        id: 1206,
        name: '使用'
      },
      {
        id: 1200,
        name: '其他'
      }
    ]
  },
  {
    id: 13,
    name: '烟花爆竹',
    children: [
      {
        id: 1301,
        name: '生产'
      },
      {
        id: 1302,
        name: '批发'
      },
      {
        id: 1303,
        name: '零售(长期)'
      },
      {
        id: 1304,
        name: '零售短期(60天以内)'
      },
      {
        id: 1300,
        name: '其他'
      }
    ]
  },
  {
    id: 14,
    name: '交通运输',
    children: [
      {
        id: 1401,
        name: '道路交通'
      },
      {
        id: 1402,
        name: '水上交通'
      },
      {
        id: 1403,
        name: '民航'
      },
      {
        id: 1404,
        name: '铁路'
      },
      {
        id: 1400,
        name: '其他'
      }
    ]
  },
  {
    id: 15,
    name: '建筑施工'
  },
  {
    id: 16,
    name: '民用爆炸物品',
    children: [
      {
        id: 1601,
        name: '生产'
      },
      {
        id: 1602,
        name: '经营'
      },
      {
        id: 1600,
        name: '其他'
      }
    ]
  },
  {
    id: 17,
    name: '金属冶炼'
  },
  {
    id: 18,
    name: '渔业生产'
  },
  {
    id: 99,
    name: '其他'
  }
]

// 监管层级改为单位行政隶属关系，下拉数据修改
export const regulatoryOption = ['中央级', '省级', '市级', '区县级', '街道、镇、乡级', '其他']



// WEBPACK FOOTER //
// ./src/Util/commonOptions.js